import React, { memo } from 'react';

const LogoutIcon = () => {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0)">
        <path
          d="M5.98008 1.0165H1.49501C1.21992 1.0165 0.99668 1.23977 0.99668 1.51483V10.4849C0.99668 10.76 1.21995 10.9833 1.49501 10.9833H5.98008C6.25566 10.9833 6.47841 11.206 6.47841 11.4816C6.47841 11.7572 6.25566 11.98 5.98008 11.98H1.49501C0.670758 11.98 0 11.3092 0 10.4849V1.51486C0 0.690607 0.670758 0.0198491 1.49501 0.0198491H5.98008C6.25566 0.0198491 6.47841 0.242599 6.47841 0.518177C6.47841 0.793755 6.25566 1.0165 5.98008 1.0165Z"
          fill="#9F9DA3" />
        <path
          d="M11.8515 6.35477L8.82157 9.34481C8.62622 9.53817 8.31028 9.53566 8.11692 9.33982C7.92356 9.14398 7.92555 8.82853 8.12191 8.63517L10.2872 6.4983H4.48502C4.20944 6.4983 3.98669 6.27555 3.98669 5.99998C3.98669 5.7244 4.20944 5.50162 4.48502 5.50162H10.2872L8.12191 3.36476C7.92558 3.1714 7.92408 2.85595 8.11692 2.66011C8.21458 2.56144 8.34316 2.51161 8.47174 2.51161C8.59833 2.51161 8.72489 2.55944 8.82157 2.65514L11.8515 5.64518C11.9462 5.73886 12 5.86645 12 6C12 6.1335 11.9467 6.26058 11.8515 6.35477Z"
          fill="#9F9DA3" />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="12" height="12" fill="white" transform="matrix(1 0 0 -1 0 12)" />
        </clipPath>
      </defs>
    </svg>

  )
};

export default memo(LogoutIcon);

